module.exports = __webpack_public_path__ + "static/media/mockup-digi.eee8c68e.jpg";